import React from 'react';
import { EditPersonDisplay, EditPersonField } from './EditPerson';
import { IEditField } from './formTools';
import { ITaskEditFormDisplayProps } from './TaskEditForm';

export const EditCompletedByDisplay: React.FC<ITaskEditFormDisplayProps> = ({ task, setIsEditing }) => (
  <EditPersonDisplay task={task} setIsEditing={setIsEditing} fullName={task.completedBy?.fullName} />
);

export const EditCompletedByField: React.FC<IEditField> = ({ submitOnChange, cancel }) => (
  <EditPersonField submitOnChange={submitOnChange} fieldName={'completedBy'} cancel={cancel} />
);
